import { combineReducers } from 'redux'
import chat from './chat/reducer'
import user from './user/reducer'

const reducer = combineReducers({
  chat,
  user
})

export default reducer